import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const OccurrenceMappingService = {
    apply: async (payload) => axios.post(`${API_URL}/occurrence_mapping/apply`, payload).then(({data}) => data.data).catch((err) => { throw err }),
};

export default OccurrenceMappingService;